
  import { COOKIE_LOAN_SEARCH } from '@/constants/cookies';
  import { createLoanSearch, updateLoanSearch } from '@/graphql/mutations/banking/loan';
  import { mapGetters } from 'vuex';
  import pick from 'lodash/pick';

  export default {
    data () {
      return {
        formDisabled: false,
        updateParams: ['amount', 'term']
      };
    },
    computed: {
      ...mapGetters('search', { search: 'get' })
    },
    methods: {
      completeSearch (search) {
        this.$cookies.set(COOKIE_LOAN_SEARCH, search.code);
        this.$router.push('/compare-loans/your-results/');
      },
      failSearch (e) {
        this.formDisabled = false;
      },
      submitForm () {
        if (!this.$validateForm(this.$el)) {
          this.formDisabled = false;
          return;
        }
        this.formDisabled = true;
        const params = pick(this.search, this.updateParams);
        if (this.search.code) {
          this.$apolloMutate(updateLoanSearch, { loanSearchId: this.search.code, params }).then(this.completeSearch).catch(this.failSearch);
        } else {
          this.$apolloMutate(createLoanSearch, { params }).then(this.completeSearch).catch(this.failSearch);
        }
      }
    }
  };
